module.exports = __webpack_public_path__ + "assets/circuit_breaker_icon.svg";